import script from "./ChartTest.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartTest.vue?vue&type=script&setup=true&lang=js"

import "./ChartTest.vue?vue&type=style&index=0&id=221232f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-221232f8"]])

export default __exports__